module.exports = __webpack_public_path__ + "img/empt.7877ef3e.png";